import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { send_component_save_request, send_request } from '../../utils/Request';
import { injectMetadataFields } from '../../utils/buildComponentSavePayload';
import useConditionalWorkflowStore, { getConditionalWorkflowStore } from './useConditionalWorkflowStore';
import useProjectStore from '../ProjectCanvas/useProjectStore';
import AddIcon from '@mui/icons-material/Add';
import ItemLogic from './components/ItemLogic';
import './components/style.css';
import { getCurrentTime } from '../../utils/getCurrentTime';
import { Grid } from '@mui/material';
import { IndividualComponentLoader } from '../../utils/ComponentLoadingSkeleton';
import CustomPaper from '../common/CustomPaper';

const ConditionalWorkflowTemplate = (props) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState(null);
  const [status, setStatus] = useState(null);

  const store = useMemo(() => getConditionalWorkflowStore(props.component_id), [props.component_id]);
  const data = store((s) => s.data);

  const insertPlaceholder = useCallback((label, text, style) => {
    const { placeholders, setPlaceholders } = store.getState();
    setPlaceholders([...placeholders, { label, text, style }]);
  }, []);

  const handleKeyChanges = (err) => {
    setError(err);
  };

  useEffect(() => {
    if (props.component_id === undefined) return;

    // If store was prefilled from canvas load, skip the REST fetch
    if (store.getState().loaded) {
      props.onComponentNameChanged(store.getState().name);
      props.onLastModifiedChanged(store.getState().lastModified);
      setLoading(false);
      props.setChildTemplateLoaded(true);
      return;
    }

    setLoading(true);
    send_request(
      `project-service/project/component/query/${props.component_id}/at-version/${props.version}`,
      '',
      {}
    )
      .then((response) => {
        if (response && response.data) {
          const { components } = response.data;
          if (components?.[0]?.componentData) {
            store.getState().setConditionalWorkflowTemplate(components[0].componentData);
            store.setState({ loaded: true });
            props.onComponentDescriptionChanged(components[0].description);
            props.onComponentNameChanged(store.getState().name);
            props.onLastModifiedChanged(store.getState().lastModified);
          }
          setLoading(false);
          props.setChildTemplateLoaded(true);
        }
      })
      .catch((err) => {
        throw Error(err.message);
      });
  }, []);

  useEffect(() => {
    const unsub = useProjectStore.subscribe(
      (s) => s.selectedPlaceholder,
      (placeholder) => {
        const activeId = useProjectStore.getState().activeComponentId;
        if (activeId !== null && activeId !== props.component_id) return;
        if (!placeholder?.selected) return;
        const { style, key } = placeholder.selected;
        insertPlaceholder(style.default, key, style);
      }
    );
    return unsub;
  }, []);

  if (!loading) {
    return (
      <CustomPaper>
        <Grid container direction={'column'} xs={12}>
          {(data?.conditions || []).map((item, index) => (
            <ItemLogic
              key={index}
              isExpanded={props.isExpanded}
              data={item}
              indexLogic={index}
              availablePlaceholders={props.availablePlaceholders}
              handleKeyChanges={handleKeyChanges}
              conditionalWorkflowPath={false}
              componentStore={store}
            />
          ))}
        </Grid>
      </CustomPaper>
    );
  } else return <IndividualComponentLoader />;
};

export default ConditionalWorkflowTemplate;
